import React, { useCallback, useImperativeHandle, useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import SydModal from '../../commonDesign/SydModal'
import ActivityDialogBodyType from './ActivityDialogBodyType'

const ActivityDialog = React.forwardRef(function ActivityDialog ({ component, componentProps, activityType }, ref) {
  const [dialogState, setDialogState] = useState({ open: false, item: null })
  const close = useCallback(() => {
    setDialogState({ open: false, item: null })
  }, [setDialogState])

  useImperativeHandle(ref, () => ({
    open: (item) => setDialogState({ open: true, item })
  }), [setDialogState])

  const title = useMemo(() => {
    return `${dialogState.item?.subject || 'View Item'}`
  }, [dialogState.item])

  return (
    <SydModal
      title={title}
      open={dialogState.open}
      onClose={close}
      size='xmedium'
      position='top'
      disablePortal={false}
    >
      <ActivityDialogBodyType
        activityType={activityType}
        component={component}
        componentProps={componentProps}
        item={dialogState?.item}
      />
    </SydModal>
  )
})

ActivityDialog.propTypes = {
  activityType: PropTypes.string,
  component: PropTypes.node,
  componentProps: PropTypes.object
}

export default ActivityDialog
